var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 18.334C1.6665 16.5659 2.36888 14.8702 3.61913 13.6199C4.86937 12.3697 6.56506 11.6673 8.33317 11.6673C10.1013 11.6673 11.797 12.3697 13.0472 13.6199C14.2975 14.8702 14.9998 16.5659 14.9998 18.334H1.6665ZM8.33317 10.834C5.57067 10.834 3.33317 8.59648 3.33317 5.83398C3.33317 3.07148 5.57067 0.833984 8.33317 0.833984C11.0957 0.833984 13.3332 3.07148 13.3332 5.83398C13.3332 8.59648 11.0957 10.834 8.33317 10.834ZM14.469 12.6948C15.7437 13.0224 16.8826 13.7439 17.7234 14.7563C18.5643 15.7688 19.0643 17.0208 19.1523 18.334H16.6665C16.6665 16.159 15.8332 14.179 14.469 12.6948ZM12.7832 10.7982C13.4815 10.1735 14.04 9.40843 14.422 8.55294C14.804 7.69745 15.0009 6.77089 14.9998 5.83398C15.0016 4.69521 14.7103 3.57513 14.154 2.58148C15.0979 2.77114 15.9469 3.28179 16.5569 4.02665C17.1668 4.7715 17.5 5.70459 17.4998 6.66732C17.5001 7.26104 17.3734 7.84795 17.1283 8.38871C16.8832 8.92948 16.5253 9.4116 16.0786 9.80277C15.632 10.1939 15.1069 10.4851 14.5385 10.6568C13.9702 10.8285 13.3717 10.8767 12.7832 10.7982V10.7982Z",
    fill: "#313544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceIcon);
export default __webpack_public_path__ + "static/media/audience_icon.027b071e0a2e31dae16258994c289532.svg";
export { ForwardRef as ReactComponent };